/* eslint-disable no-undef */
/* eslint-disable react/jsx-closing-bracket-location */
import { Avatar, Box, Button, Container, Grid, makeStyles, useMediaQuery } from '@material-ui/core';
import React, { useState, useEffect } from 'react';
import propTypes from 'prop-types';
import { useFirebase } from 'react-redux-firebase';
import { formatText } from '../helpers';

const useStyles = (small) => {
  return makeStyles((theme) => ({
    message: {
      flexWrap: 'nowrap',
      margin: '8px 0 16px 0',
      justifyContent: 'flex-end',
    },
    img: {
      width: '30px',
      height: '30px',
      margin: '0 8px',
    },
    body: {
      display: 'flex',
      flexDirection: 'column',
      padding: 0,
    },
    datetime: {
      fontSize: '0.8rem',
    },
    messageContainer: {
      padding: '16px',
      overflowWrap: 'break-word',
      background: 'rgb(251, 251, 251)',
      border: '1px solid rgba(0, 0, 0, 0.05)',
      maxWidth: !small ? '700px' : '100%',
    },
    whiteSpace: {
      whiteSpace: 'pre-line',
    },
    imagesAndFiles: {
      width: 'fit-content',
      maxWidth: '300px',
      cursor: 'pointer',
      transition: 'all .3s',
      '&:hover': {
        transform: 'scale(1.1)',
      },
    },
  }));
};

function Message(props) {
  const small = useMediaQuery('(max-width:600px)');
  const classes = useStyles(small)();
  const [disableButton, setDisableButton] = useState([]);
  const [message, setMessage] = useState(...props.message);
  const firebase = useFirebase();
  const ref = firebase.storage().ref();

  const folders = {
    image: 'images',
    audio: 'voice_records',
    file: 'files',
  };

  const getMediaUrl = async (contentType, path) => {
    return ref.child(`${folders[contentType]}/${path}`).getDownloadURL();
  };

  const filterButtonFromMessage = (message) => {
    try {
      let filteredMessage = message;
      const buttonIndex = filteredMessage.indexOf('<button>');
      if (buttonIndex !== -1) {
        filteredMessage = filteredMessage.slice(0, buttonIndex);
      }
      return filteredMessage;
    } catch (error) {
      // eslint-disable-next-line no-console
      console.error('filterButtonFromMessage:', error);
      return message;
    }
  };

  const buttons = props.message
    .split('<button>')
    .slice(1)
    .map((e) => e.slice(0, e.indexOf('</button>')));

  useEffect(() => {
    if (props.hasDownload) {
      getMediaUrl(props.contentType, props.message).then((res) => {
        setMessage(res);
      });
    } else {
      setMessage(filterButtonFromMessage(props.message));
    }
  }, [props.hasDownload, props.contentType, props.message]);

  return (
    <Grid
      container
      className={classes.message}
      style={{ justifyContent: props.forMe ? 'flex-start' : 'flex-end' }}>
      <Box display="flex">
        {props.forMe && <Avatar className={classes.img} src={props.image} />}
        <Container className={classes.body}>
          <span className={classes.datetime}>{props.date}</span>
          <Box
            className={`${classes.messageContainer} message`}
            style={{
              borderRadius: props.forMe ? '0.3em 1.4em 1.4em 1.4em' : '1.4em 0.3em 1.4em 1.4em',
            }}>
            {props.contentType === 'chat' && (
              <>
                <span className={classes.whiteSpace}>{formatText(message)}</span>
                <br />
                <Box display="flex" flexDirection="column">
                  {buttons.map((buttonName) => (
                    <Box mb={1} key={buttonName}>
                      <Button
                        variant="outlined"
                        onClick={() => {
                          props.onSendMessage({ message: buttonName });
                          setDisableButton([...disableButton, { date: props.date }]);
                        }}
                        disabled={disableButton.find((e) => e.date === props.date)}>
                        {buttonName}
                      </Button>
                    </Box>
                  ))}
                </Box>
              </>
            )}
            {props.contentType !== 'chat' && (
              <>
                <img
                  src={
                    props.contentType === 'image'
                      ? message
                      : 'https://s1.eestatic.com/2018/05/02/actualidad/actualidad_304233531_130193551_1024x576.jpg'
                  }
                  className={classes.imagesAndFiles}
                  onClick={() => {
                    window.open(message);
                  }}
                  style={props.contentType === 'file' ? { maxWidth: '200px' } : {}}
                />
              </>
            )}
          </Box>
        </Container>
      </Box>
    </Grid>
  );
}

const Props = {
  hasDownload: propTypes.bool,
  message: propTypes.string.isRequired,
  image: propTypes.string,
  forMe: propTypes.bool.isRequired,
  date: propTypes.string.isRequired,
  onSendMessage: propTypes.func,
  contentType: propTypes.string,
};

Message.propTypes = Props;

export default Message;
